import {
  SITE_DOCUMENTS_LIST_REQUEST,
  SITE_DOCUMENTS_LIST_SUCCESS,
  SITE_DOCUMENTS_LIST_FAIL,
  SITE_DOCUMENT_UPSERT_SUCCESS,
  SITE_DOCUMENT_DELETE_SUCCESS,
} from "../constants/siteDocumentConstants";

const initial = {
  loading: false,
  error: null,
  documents: [],
  documentsMap: {}, // { key: doc }
};

export const siteDocumentsReducer = (state = initial, action) => {
  switch (action.type) {
    case SITE_DOCUMENTS_LIST_REQUEST:
      return { ...state, loading: true, error: null };
    case SITE_DOCUMENTS_LIST_SUCCESS: {
      const { documents = [], map = {} } = action.payload || {};
      return { ...state, loading: false, documents, documentsMap: map };
    }
    case SITE_DOCUMENTS_LIST_FAIL:
      return { ...state, loading: false, error: action.payload };

    case SITE_DOCUMENT_UPSERT_SUCCESS: {
      const doc = action.payload;
      const documents = [
        ...state.documents.filter(
          (d) => d._id !== doc._id && d.key !== doc.key
        ),
        doc,
      ];
      const documentsMap = { ...state.documentsMap, [doc.key]: doc };
      return { ...state, documents, documentsMap };
    }

    case SITE_DOCUMENT_DELETE_SUCCESS: {
      const id = action.payload;
      const documents = state.documents.filter((d) => d._id !== id);
      const documentsMap = {};
      for (const d of documents) documentsMap[d.key] = d;
      return { ...state, documents, documentsMap };
    }

    default:
      return state;
  }
};
